import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import TravelHomePage from './pages/TravelHomePage';
import ExplorePage from './pages/ExplorePage';
import CruisePage from './pages/CruisePage';
import CruiseResultsPage from './pages/CruiseResultsPage';
import CruiseMobileSupportPopup from './components/cruises/CruiseMobileSupportPopup';
import CruiseGtagTracker from './components/cruises/CruiseGtagTracker';
import FlightApp from './flights/FlightApp';
import AirlineLandingPage from './southwest/SouthwestPage';
import AirlineFlightSearchPage from './southwest/FlightSearchPage';
import {
  AIRLINE_LANDINGS,
  airlinePath,
  airlineResultsPath,
  isAirlinePath,
} from './southwest/airlines';
import {
  CRUISE_PAGE_META,
  CRUISE_SEARCH_META,
  DEFAULT_PAGE_META,
  FLIGHT_PAGE_META,
} from './constants/pageMeta';
import { applyPageMeta } from './utils/usePageMeta';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function AppRoutes() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.startsWith('/cruises/search')) {
      applyPageMeta(CRUISE_SEARCH_META);
    } else if (pathname.startsWith('/cruises')) {
      applyPageMeta(CRUISE_PAGE_META);
    } else if (pathname.startsWith('/flight')) {
      applyPageMeta(FLIGHT_PAGE_META);
    } else if (isAirlinePath(pathname)) {
      // Airline pages set their own document title/description
    } else {
      applyPageMeta(DEFAULT_PAGE_META);
    }
  }, [pathname]);

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/explore" element={<ExplorePage />} />
        <Route path="/cruises" element={<CruisePage />} />
        <Route path="/cruises/search" element={<CruiseResultsPage />} />
        <Route path="/flight/*" element={<FlightApp />} />
        {AIRLINE_LANDINGS.map((airline) => (
          <Route
            key={airline.slug}
            path={airlinePath(airline.slug)}
            element={<AirlineLandingPage slug={airline.slug} />}
          />
        ))}
        {AIRLINE_LANDINGS.map((airline) => (
          <Route
            key={`${airline.slug}-search`}
            path={airlineResultsPath(airline.slug)}
            element={<AirlineFlightSearchPage slug={airline.slug} />}
          />
        ))}
        <Route path="*" element={<TravelHomePage />} />
      </Routes>
      {pathname.startsWith('/cruises') && <CruiseGtagTracker />}
      {pathname.startsWith('/cruises') && <CruiseMobileSupportPopup />}
    </>
  );
}

function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default App;
